import { colors } from '&assets/constants/colors';
import { device } from '&assets/constants/responsiveness';
import styled from 'styled-components';

export const PrizesWrapper = styled.div`
	min-height: 300px;
	max-height: fit-content;
	box-sizing: border-box;
	width: 100%;
	overflow: hidden;
	background-color: ${colors.primary};

	.content {
		height: 100%;
		padding: 50px 0px;
		display: flex;
		flex-direction: column;
		position: relative;
		overflow: visible;

		.shading-first {
			background: linear-gradient(45deg, #001df5 50%, #018fcc);
			width: 400px;
			height: 400px;
			position: absolute;
			top: -200px;
			left: 0;
			transform: rotate(45deg) !important;
		}
		.shading-second {
			background: linear-gradient(45deg, #001df5 50%, #018fcc);
			width: 400px;
			height: 400px;
			position: absolute;
			top: -200px;
			right: 0;
			transform: rotate(45deg) !important;
		}
		.title {
			color: ${colors.white};
			font-size: 3.25rem;
			font-family: 'Segnifier-Regular';
			margin: 0;
			margin-bottom: 48px;
		}
		.apply-now {
			background: #6ebbac;
			margin: 48px auto;
		}
		.cards {
			width: 100%;
			display: flex;
			flex-direction: row;
			justify-content: space-between;
			align-items: center;
			flex-wrap: wrap;
			box-sizing: border-box;

			.card {
				height: 300px;
				width: 23%;
				border-bottom: 8px solid #6ebbac;
				background: ${colors.white};
				display: flex;
				flex-direction: column;
				justify-content: center;
				align-items: flex-start;
				margin: 0 10px;
				padding: 41px;
				box-sizing: border-box;
				margin-bottom: 10px;
				.number {
					color: ${colors.primary};
					font-size: 48px;
					font-style: normal;
					font-weight: 400;
					line-height: 44px;
					letter-spacing: -0.4px;
				}
				.prize {
					color: #6ebbac;
					font-size: 10px;
					font-style: normal;
					font-weight: 700;
					line-height: 16px;
					letter-spacing: -0.1px;
					text-transform: uppercase;
				}
				.subtitle {
					color: #001df5;
					font-size: 24px;
					font-style: normal;
					font-weight: 400;
					line-height: 24px;
					letter-spacing: -0.6px;
					align-self: center;
				}
				.description {
					margin-bottom: 70px;
					color: ${colors.textDark};
					font-weight: bold;
					font-size: 16px;
					font-style: normal;
					line-height: 28px;
					letter-spacing: -0.6px;
				}
			}
		}
		.large {
			height: 536px !important;
		}
	}
	@media ${device.tablet} {
		.content {
			padding: 20px;
			width: 100%;
			box-sizing: border-box;
			.title {
				margin: 0;
				margin-bottom: 30px;
			}
			.cards {
				.card {
					width: 22%;
				}
			}
			.apply-now {
				margin-top: 20px;
			}
		}
	}

	@media ${device.mobile} {
		.content {
			padding: 20px;
			width: 100%;
			box-sizing: border-box;
			.title {
				margin: 0;
				margin-bottom: 30px;
			}
			.cards {
				width: 100%;
				display: flex;
				flex-direction: column;
				justify-content: space-between;
				align-items: center;
				.card {
					width: 50%;
					margin: 0;
					margin-bottom: 20px;
					padding: 30px 20px;
				}
			}
			.apply-now {
				margin-top: 20px;
			}
		}
	}
`;
